var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 3H4.2a4.2 4.2 0 000 8.4h5.6a4.2 4.2 0 100-8.4zm0 7.467H4.2a3.267 3.267 0 010-6.534h5.6a3.267 3.267 0 110 6.534zm0-5.6a2.333 2.333 0 100 4.666 2.333 2.333 0 000-4.666zm0 3.733a1.4 1.4 0 110-2.8 1.4 1.4 0 010 2.8z"
  })));
}
export default SvgToggle;